exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-card--material-stats{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;position:relative}.v-card--material-stats>div:first-child{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.v-card--material-stats .v-card{border-radius:4px;-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto}.v-card--material-stats .v-card__text{display:inline-block;-webkit-box-flex:1;-ms-flex:1 0 calc(100% - 120px);flex:1 0 calc(100% - 120px);position:absolute;top:0;right:0;width:100%}.v-card--material-stats .v-card__actions{-webkit-box-flex:1;-ms-flex:1 0 100%;flex:1 0 100%}", ""]);

// exports
